import { NgModule } from '@angular/core';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmptyLayoutModule } from 'app/layout/layouts/empty/empty.module';
import { ClassicLayoutModule } from 'app/layout/layouts/vertical/classic/classic.module';
import { SettingsModule } from 'app/layout/common/settings/settings.module';
import { SharedModule } from 'app/shared/shared.module';
import { ShiftDataService } from 'app/components/shift-data-analysis/shift-data.service';
import { LanguagesModule } from './common/languages/languages.module';
import { DownloadsModule } from './common/downloads/downloads.module';

const layoutModules = [
    // Empty
    EmptyLayoutModule,

    // Horizontal navigation

    // Vertical navigation
    ClassicLayoutModule,
];

@NgModule({
    declarations: [LayoutComponent],
    imports: [SharedModule, SettingsModule,LanguagesModule,DownloadsModule, ...layoutModules],
    exports: [LayoutComponent, ...layoutModules],
    providers: [ShiftDataService],
})
export class LayoutModule {}
